var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{attrs:{"color":"indigo","app":"","clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.sidebar = !_vm.sidebar}}},[_c('v-icon',[_vm._v("mdi-menu")])],1),_c('v-toolbar-title',[_vm._v("App")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }